module.exports = __webpack_public_path__ + "static/scratch-club-b279731f976bc13d293273472774a8c1.png";